<template>
  <div
    class="sorting overlay"
    :class="{
      'overlay--open': isOpen,
    }"
  >
    <p class="overlay__title">Sortér</p>
    <button
      @click.prevent="changeState"
      class="overlay__button search-results-container__button"
      type="menu"
    >
      <div class="overlay__text-container">
        <img
          loading="lazy"
          class="search-results-container__button-icon"
          src="/static/icons/sort.svg"
          alt="Sortér"
        />
        <p class="search-results-container__button-text--sorting">Sortér</p>
      </div>
      <Arrow :direction="isOpen ? 'up' : 'down'" />
    </button>
    <div class="overlay__container">
      <div class="overlay__top-container">
        <div class="overlay__placeholder"></div>
        <div class="overlay__top">Sortér</div>
        <button @click.prevent="changeState" class="overlay__top" type="button">
          <div aria-label="Luk" class="icon--plus icon--rotate"></div>
        </button>
      </div>
      <List
        :type="'radio'"
        :search-type="'sorting'"
        :event-bus="proxyBus"
        :items="items"
        :trigger-when-loaded="false"
      ></List>
    </div>
  </div>
</template>

<script>
import mitt from 'mitt'

import Arrow from '@shared/Arrow/Arrow.vue'
import List from '@search/List/List.vue'

import UidMixin from '@shared/uid-mixin.vue'
import SearchComponentsMixin from '@search/search-components-mixin.vue'

export default {
  mixins: [SearchComponentsMixin, UidMixin],
  data() {
    return {
      isOpen: false,
      proxyBus: null,
      listenerEvent: null,
    }
  },
  components: {
    Arrow,
    List,
  },
  props: {
    eventBus: { default: null, type: Object },
    items: { default: null, type: Array },
  },
  methods: {
    changeState() {
      if (this.isOpen) {
        this.closeDropdown()
      } else {
        window.history.pushState(null, '', null)

        window.addEventListener('popstate', this.closeDropdown)

        this.isOpen = true
      }
    },
    closeDropdown(isPopstate = false) {
      if (!isPopstate) {
        window.history.back()
      }

      this.isOpen = false

      window.removeEventListener('popstate', this.closeDropdown)
    },
    searchRequestCallback(options) {
      this.eventBus.emit('sorting-callback', options.value)
    },
  },
  watch: {
    isOpen: {
      handler(val) {
        const body = document.getElementsByTagName('body')[0]
        const func = this.closeDropdown
        if (val) {
          this.listenerEvent = event => {
            const pathList = event.composedPath()
            let triggerFunc = false
            pathList.forEach(current => {
              if (
                (current.classList &&
                  current.classList.contains('overlay__top-container')) ||
                (current.classList &&
                  current.classList.contains('list__item-container') &&
                  current.getElementsByTagName('input')[0].checked)
              )
                return

              if (
                (current.tagName &&
                  current.tagName.toLowerCase() == 'button' &&
                  current.classList &&
                  current.classList.contains('overlay__button')) ||
                (current.classList &&
                  current.classList.contains('overlay__container')) ||
                (current.classList &&
                  current.classList.contains('overlay__top'))
              ) {
                return
              }

              triggerFunc = true
            })
            if (triggerFunc) {
              func()
            }
          }
          body.addEventListener('mouseup', this.listenerEvent)
        } else {
          body.removeEventListener('mouseup', this.listenerEvent)
        }
      },
    },
  },
  created() {
    this.proxyBus = mitt()
    this.proxyBus.on('search-request-callback', this.searchRequestCallback)
  },
}
</script>

<style lang="scss">
@import 'Sorting.scss';
@import '@shared/Overlay/Overlay.scss';
</style>
